<template>
    <div class="logfiles">
        <!--b-overlay
            :show="busy"
            rounded
            opacity="0.6"
            spinner
            spinner-variant="bruvis"
        -->
            <b-table 
                striped hover 
                :items="userlist" 
                :fields="fields" 
                :busy="isBusy"
                @row-clicked="openLog"
                style="cursor: pointer;"
            >
                <template #table-busy>
                    <div class="text-center text-dark my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Отримання списку...</strong>
                    </div>
                </template>
            </b-table>    

        <!--/b-overlay-->
        <b-modal 
            id="logfile-modal" 
            size="lg"
            hide-header-close- 
            centered 
            scrollable 
            :no-close-on-backdrop="true" 
            ok-only
            ok-variant="bruvis"
            ok-title="Закрити"
            @hidden = "text = null,targetName = null"
            >
            <template #modal-title>
                <b-icon icon="printer" class="rounded bg-bruvis p-1" variant="light" font-scale="1.3"></b-icon> 
                <span class="p-2 h5 mr-auto">Журнал {{targetName}}</span>
            </template>

             <b-overlay
                :show="logbusy"
                rounded
                opacity="0.6"
                spinner
                spinner-variant="bruvis"
            >
                <pre>{{text}}</pre>
             </b-overlay>
            
        </b-modal>            
    </div>            
</template>

<script>

export default {
  name: 'LogFilesViewer',
  props: {
    
  },
  data: () => ({
    busy: false,
    logbusy: false,
    userlist: null,
    fields:[
        {key :'name',label:'Користувач',sortable: true},
        {key :'date',label:'Коли користувався востаннє',sortable: true}
    ],
    targetName: null,
    text: null
  }),  
  methods: {

    getUserList(){
        this.busy = true
        this.$axios.post('', {"action":"getuserlist"})
            .then((res) => {
                this.busy = false  
                if(res.data.success != false && res.data.success != 'false'){
                    this.userlist = res.data.userlist
                    this.$toasted.success('Список наявних логфайлів отримано').goAway(2000)
                }else{
                    if(res.data.error=="auth" || res.data.error=="tokenout"){
                        this.$emit('needlogin')
                    }else{
                        this.$toasted.error('Помилка отримання списку логфайлів').goAway(3000)
                        this.$toasted.error(res.data.error).goAway(3000)
                    }    
                }
                    
            })
            .catch(error => {
            console.error('There was an error!', error)
            });
    },
    openLog(item){
        this.logbusy = false
        this.targetName = item.name
        if(!item.name) return
        this.$bvModal.show('logfile-modal')
        this.$axios.post('', {"action":"getlog","rn":item.name})
            .then((res) => {
                this.logbusy = false  
                if(res.data.success != false && res.data.success != 'false'){
                    this.text = res.data.text
                }else{
                    if(res.data.error=="auth" || res.data.error=="tokenout"){
                        this.$emit('needlogin')
                    }else{
                        this.text = 'Помилка'
                    }    
                }
                    
            })
            .catch(error => {
            console.error('There was an error!', error)
            });
    }
 
  },
  
  mounted() {
    this.getUserList()
  },

    computed: {
        
    }
}
</script>

<style scoped>


@media (max-width: 575px) {
  

}

@media (hover: none) {


}    



</style>
